/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { createStore } from "@evertrue/et-flux";

import LidsSource from "apps/auth/sources/lids-source";
import SessionSource from "apps/auth/sources/session-source";

export default createStore("LidsStore", {
  getInitialState() {
    return {
      account: undefined,
      activated: false,
    };
  },

  registerActions() {
    this.on(SessionSource.actions.setSession, function(session, is_registration_session) {
      // Dont want to load the linkedin association right after registration
      // because it will fail
      if (session.user && !is_registration_session) {
        return LidsSource.fetchLinkedinAssociation();
      }
    });

    this.on(LidsSource.actions.fetchedLinkedinAssociation, function(account) {
      return this.setState({ account });
    });

    this.on(LidsSource.actions.destroyedLinkedinAssociation, function() {
      return this.setState({ account: undefined });
    });

    return this.on(LidsSource.actions.completedAssociation, function(token) {
      return this.setState({ activated: true });
    });
  },

  api: {
    isConnected() {
      return !!(this.getState("account") || this.getState("activated"));
    },

    hasActivated() {
      return this.getState("activated");
    },
  },
});
